<template>
    <section v-if="json" class="page-careers">
        <SimpleFold
            :bgStyle="json.careersBackground?.[0]?.bgStyle"
            :bgStyleMobile="json.careersBackgroundMobile?.[0]?.bgStyle"
            :bgVideo="json.careersBackgroundVideo?.[0]?.url"
            :bgVideoMobile="json.careersBackgroundVideoMobile?.[0]?.url"
            :youtubeId="json.youTubeId2"
            :title="json.panelTitle"
            :subtitle="json.subtitle"
        />
        <CurrentOpenings/>
        <VisionMissionCareers v-if="careersLoaded" :json="json"></VisionMissionCareers>
        <!--<OurStudioCulture v-if="careersLoaded" :json="json"/>-->
        <DigitalFirst v-if="careersLoaded" :json="json"/>
        <OfficePanels v-if="careersLoaded" :json="json.officePanels"/>
        <ValuesPanels v-if="careersLoaded" :json="json.valuesPanels"/>

        <InternshipBenefitsPerks v-if="careersLoaded" :json="json"/>
    </section>
</template>

<script>
import axios from 'axios'
import gh from '@/helpers/gh'
import SimpleFold from "@/components/blocks/SimpleFold";
import CurrentOpenings from "@/components/blocks/CurrentOpenings";
import VisionMissionCareers from "@/components/blocks/VisionMissionCareers";
//import OurStudioCulture from "@/components/blocks/OurStudioCulture";
import DigitalFirst from "@/components/blocks/DigitalFirst";
import InternshipBenefitsPerks from "@/components/blocks/InternshipBenefitsPerks";
import OfficePanels from "@/components/blocks/OfficePanels";
import ValuesPanels from "@/components/blocks/ValuesPanels";
import {mapState} from "vuex";
export default {
    name: "CommunityPath",
    components: {
        SimpleFold,
        DigitalFirst,
        VisionMissionCareers,
        CurrentOpenings,
        //OurStudioCulture,
        InternshipBenefitsPerks,
        OfficePanels,
        ValuesPanels
    },
    data () {
        return {
            window: window,
            json: null,
            gh: gh,
            careersLoaded: false
        }
    },
    computed: {
        ...mapState({
            careersJson: state => state.careersJson,
        }),
    },
    watch: {
        careersJson() {
            if (this.careersJson !== null) {
                this.careersLoaded = true
            }
        },
    },
    mounted () {
        let slug = this.$route.fullPath
        slug = gh.stripSlashesFrontAndBack(slug)
        const turl = gh.formatFeedUrl(slug)
        axios.get((turl))
            .then((res) => {
                this.json = res.data

                if (this.careersJson !== null) {
                    this.careersLoaded = true
                }

            }).catch((e) => {
            console.error('Error', slug, e)
        })


    },
    beforeUnmount() {

    },
    methods: {

    }
}
</script>